export function useClearShipperContact(modelValue) {

    modelValue.shipperContactId = 0;
    modelValue.shipperContactFullName = '';
    modelValue.shipperContactTitle = '';
    modelValue.shipperContactFirstName = '';
    modelValue.shipperContactLastName = '';
    modelValue.shipperContactPhone = '';
    modelValue.shipperContactEmail = '';
    modelValue.shipperContactDepartment = '';
}
